/**
 * @description: 仓库管理-实时库存
 * @author: ccy
 * @update: hwx
 */
<template>
    <div>
        <div class="actual-stock">
            <p class="p-hint">注：实时库存列表不显示商品属性设置“是否盘点”为否的商品</p>
            <div class="row row-margin">
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="selectstore" data-placeholder="请选择门店"></select>
                </div>
                <label class="list-label-2">仓库:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="printer_stock_input" data-placeholder="请选择仓库" disabled>
                    </select>
                </div>
                <label class="list-label-4">销售商品:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="actual_sale" data-placeholder="是否销售商品">
                        <option value=" ">全部</option>
                        <option value="1">是</option>
                        <option value="-1">否</option>
                    </select>
                </div>
                <label class="list-label-2">类型:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="selecttypes"></select>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">商品名称:</label>
                <div class="col-md-2">
                    <input class="form-control" placeholder="请输入商品名称" v-model="goods_name">
                </div>
                <label class="list-label-4">截止日期:</label>
                <div class="col-md-2">
                    <div ref="actTime">
                        <input type="text" class="form-control act-endtime" v-model="act_endtime" placeholder="请选择截止时间" readonly>
                    </div>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">库存总量:</label>
                <div class="list-total" ref="stock_total"></div>
                <label class="list-label-6">成本总额合计:</label>
                <div class="list-total" ref="stock_price_total"></div>
            </div>
            <div class="row">
                <div class="pull-right">
                    <button type="button" class="stock-order btn btn-flat btn-middle btn-border-orange btn-orange" @click="stockOrder(0)">按实时库存排序</button>
                    <button type="button" class="stock-order btn btn-flat btn-middle btn-border-gray" @click="stockOrder(1)">按商品类型名称排序</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-orange btn-orange" @click="getExportSet">导出</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-orange btn-orange" @click="searchStockList">查询</button>
                    <button type="button" class="btn btn-flat btn-middle btn-border-orange btn-orange" v-show="!query" @click="searchLack">缺货查询</button>
                    <button type="button" class="btn btn-flat btn-middle btn-border-orange btn-orange" v-show="query" @click="cancelLack">取消缺货查询</button>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="stockTable"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="export_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='export_allcheck' @click='exportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="shop_name">
                            <label>全部门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="store_name">
                            <label>仓库</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="merchant_goods_name">
                            <label>商品名称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="goods_type_name">
                            <label>类型</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="goods_unit_name">
                            <label>单位</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="is_sell">
                            <label>销售商品</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="remain_total">
                            <label>实时库存</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="price">
                            <label>成本单价</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="price_total">
                            <label>成本总额</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='export_checkModel' value="alerte_total">
                            <label>最小库存预警</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='export_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='export_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="shade" v-show="popup"></div>
        <div class="popup" v-show="popup">
            <div class="popclose" @click="closePop"></div>
            <div>
                <div class="poptitle">最小库存预警修改</div>
                <div class="timeContent">
                    <input class="changestock" placeholder="请输入最小库存预警">
                    <div class="popbottom">
                        <button class="btn btn-flat btn-middle btn-border-orange btn-orange popbtn">确定</button>
                        <button class="btn btn-flat btn-middle btn-border-gray pull-right popbtn" @click="closePop">取消</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import Vue from 'vue';
    export default {
        name: 'actual_stock',
        data () {
            return {
                msg: 'actual_stock',
                query: false,
                popup: false,
                merchantList: [],
                typeList: [],
                shopId: null,
                goods_type: "",
                goods_name: "",
                is_lack: 0,
                paramsdatas: null,
                act_endtime: '',

                order: 'stock._remain_total ASC',
                order_by: "",
                sort_by: "",
                stk_stb: true,

                export_allcheck: false,
                c_export_allcheck: false,
                export_checkModel: [],
                export_checkData: ['shop_name', 'store_name', 'merchant_goods_name', 'goods_type_name', 'goods_unit_name', 'is_sell', 'remain_total', 'price', 'price_total', 'alerte_total'],
                export_type: 1,
            }
        },
        watch: {
            export_checkModel: {
                handler: function(val, oldVal) {
                    if(this.export_checkModel.length >= this.export_checkData.length) {
                        this.export_allcheck = true;
                        this.c_export_allcheck = true;
                    } else {
                        this.export_allcheck = false;
                        this.c_export_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted() {
            $(this.$refs.actual_sale).select2({
                minimumResultsForSearch: -1,
                language: "zh-CN",
                width: '100%'
            });
            this.innitDate();
            this.getGoodsType();
            this.getshopdata();
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.actTime).daterangepicker({
                    singleDatePicker: true, // 设置成单日历
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray'
                }, function(start, end, label) {
                    _this.act_endtime = start.format('YYYY-MM-DD 08:00');
                });
            },
            // 门店数据
            getshopdata: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            let arr = [];
                            $.each(data.response.result, function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            $(_this.$refs.selectstore).select2({
                                data: arr,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                if(e.params.data.text == "全部") {
                                    _this.initi_list_box('');
                                    $(_this.$refs.printer_stock_input).prop("disabled", true);
                                    return;
                                }
                                $(_this.$refs.printer_stock_input).prop("disabled", false);
                                _this.getstockdata(e.params.data.id);
                            });
                            $(_this.$refs.selectstore).val(data.response.result[1].id).trigger('change');
                            $(_this.$refs.printer_stock_input).prop("disabled", false);
                            _this.getstockdata(data.response.result[1].id);
                            _this.initStockTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {

                    }
                });
            },
            // 仓库数据
            getstockdata: function(shop_id, type, cur_id) {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                };
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl+"PublicData/api_getStoreList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            if(type == "false") {
                                _this.shop_stockdata = [];
                                $.each(data['response']['result'], function(k, v) {
                                    _this.shop_stockdata.push({ id: v.id, text: v.name });
                                });
                                $(_this.$refs.add_stock_name).html("");
                                $(_this.$refs.add_stock_name).select2({
                                    data: _this.shop_stockdata,
                                    minimumResultsForSearch: -1,
                                    language: "zh-CN"
                                }).select2("val", [cur_id]);
                                return;
                            }
                            let arr = [{ id: " ", text: "全部" }];
                            $.each(data['response']['result'], function(k, v) {
                                arr.push({ id: v.id, text: v.name });
                            });
                            _this.initi_list_box(arr);
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {
                        layer.msg('出错啦');
                    }
                });
            },
            initi_list_box: function(arr) {
                $(this.$refs.printer_stock_input).html("");
                $(this.$refs.printer_stock_input).select2({
                    data: arr,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                });
            },
            // 获取商品类型
            getGoodsType: function () {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                    },
                    "comment": []
                };
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getGoodsType",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            let result = data.response.result.data;
                            let item = {
                                id: "0",
                                name: "全部"
                            };
                            result.unshift(item);
                            _this.initTypeSuggest(result);
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 初始化商品类型
            initTypeSuggest: function(result) {
                let _this = this;
                $.each(result, function(k, v) {
                    _this.typeList.push({ id: v.id, text: v.name });
                });
                $(_this.$refs.selecttypes).html("");
                $(_this.$refs.selecttypes).select2({
                    data: _this.typeList,
                    minimumResultsForSearch: -1,
                    language: "zh-CN"
                }).on("select2:select",function(e){
                    
                });
            },
            stockOrder: function(num) {
                let _this = this;
                $('.stock-order').removeClass('btn-orange');
                $('.stock-order').removeClass('btn-border-orange');
                $('.stock-order').removeClass('btn-border-gray');
                if(num == 0) {
                    $('.stock-order').eq(0).addClass('btn-orange');
                    $('.stock-order').eq(0).addClass('btn-border-orange');
                    $('.stock-order').eq(1).addClass('btn-border-gray');
                    _this.order = 'stock._remain_total ASC';
                    _this.stk_stb = true;
                    _this.initStockTable();
                } else if(num == 1) {
                    $('.stock-order').eq(0).addClass('btn-border-gray');
                    $('.stock-order').eq(1).addClass('btn-orange');
                    $('.stock-order').eq(1).addClass('btn-border-orange');
                    _this.order = 'stock._goods_type ASC,goods._goods_name ASC';
                    _this.stk_stb = false;
                    _this.initStockTable();
                }
            },
            // 初始化实时库存列表
            initStockTable: function() {
                let _this = this;
                let actionEvents = {
                    'click .editicon': function(e, value, row, index) {
                        $(this).prev().css("border", "1px solid #eee");
                        $(this).prev().attr("contenteditable", true);
                        $(this).addClass("editiconend");
                        $(this).prev().focus();
                    },
                    'keypress .editinput': function(e, value, row, index) {
                        if(event.keyCode == "13") {
                            $(this).blur();
                        }
                    },
                    'blur .editinput': function(e, value, row, index) {
                        $(this).css("border", "none");
                        $(this).attr("contenteditable", false);
                        $(this).next().removeClass("editiconend");
                        if(isNaN($(this).text())) {
                            layer.msg("请输入数字",{
                                time: 1200
                            });
                            $(this).text(row.alerte_total);
                            return;
                        }
                        if(($(this).text() < 0) || ($(this).text() == '')) {
                            layer.msg("最小库存预警需大于等于0",{
                                time: 1200
                            });
                            $(this).text(row.alerte_total);
                            return;
                        }
                        if(!_this.isDecimal($(this).text())){
                            layer.msg("最小库存预警应是整数",{
                                time: 1200
                            });
                            $(this).text(row.alerte_total);
                            return;
                        }
                        let num = $(this).text();
                        _this.updateStock(row.id,num);
                        $(_this.$refs.stockTable).bootstrapTable('refresh');
                    }
                };
                $(_this.$refs.stockTable).bootstrapTable("destroy");
                $(_this.$refs.stockTable).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    ajax:function(params){
                        _this.paramsdatas = params;
                        _this.getStockList(params);
                    },
                    sortable: true,
                    sortOrder: 'asc',//升序
                    sortName: 'remain_total',
                    sidePagination: "server",
                    pagination: true,
                    columns: [{
                        field: "shop_name",
                        title: "全部门店",
                        width: "15%"
                    }, {
                        field: "store_name",
                        title: "仓库",
                        width: "8%"
                    }, {
                        field: "merchant_goods_name",
                        title: "商品名称",
                        width: "15%"
                    }, {
                        field: "goods_type_name",
                        title: "类型",
                        width: "8%"
                    }, {
                        field: "goods_unit_name",
                        title: "单位",
                        width: "6%"
                    }, {
                        field: "is_sell",
                        title: "销售商品",
                        width: "8%",
                        formatter: function(value, row, index) {
                            if(row.is_sell == 1) {
                                return '是';
                            } else if(row.is_sell == -1) {
                                return '否';
                            }
                        }
                    }, {
                        field: "remain_total",
                        title: "实时库存",
                        width: "11%",
                        sortable: _this.stk_stb,
                        formatter: function (value, row, index) {
                            if ( Number(row["alerte_total"]) < Number(row["remain_total"]) ) {
                                return '<span>' + row["remain_total"] + '</span>';
                            } else {
                                return '<span class="red-text">' + row["remain_total"] + '</span>';
                            }
                        }
                    }, {
                        field: "price",
                        title: "成本单价",
                        width: "6%"
                    }, {
                        field: "price_total",
                        title: "成本总额",
                        width: "6%"
                    }, {
                        field: "alerte_total",
                        title: "最小库存预警",
                        width: "15%",
                        events: actionEvents,
                        formatter: function (value, row, index) {
                            if(Number(row.remain_total) >= Number(row.alerte_total)){
                                return '<div class="editinput" contenteditable="false">'+row.alerte_total+'</div>' +
                                    '<a class="editicon"></a>';
                            } else {
                                return '<div class="editinput" contenteditable="false">'+row.alerte_total+'</div>' +
                                    '<a class="editicon"></a>';
                            }
                        },
                        sortable: _this.stk_stb
                    }]
                });
            },
            // 获取实时库存列表
            getStockList: function(params) {
                let _this = this;
                let pageNumber = 1;
                _this.order_by = params.data.sort;
                _this.sort_by = params.data.order;
                if(_this.stk_stb) {
                    _this.order = 'stock._' + params.data.sort + ' ' + params.data.order;
                }
                if(params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let shop_id = $(_this.$refs.selectstore).val();
                let store_id = "";
                
                if($(_this.$refs.printer_stock_input).val() !== null && $(_this.$refs.printer_stock_input).val() != "") {
                    store_id = $.trim($(_this.$refs.printer_stock_input).val());
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": "10",
                            "shop_id": shop_id,
                            "store_id": store_id,
                            "is_sell": $.trim($(_this.$refs.actual_sale).val()),
                            "is_lack": _this.is_lack,//缺货查询
                            "goods_type": $(_this.$refs.selecttypes).val(),//商品类型
                            "merchant_goods_name": _this.goods_name,
                            "time": _this.act_endtime,
                            "order": _this.order,
                            "order_by": _this.order_by || '',
                            "sort_by": _this.sort_by || ''
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/searchStockList",
                    data: {
                        json: datas2
                    },
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.data.total,
                                rows: data.response.result.data.rows
                            });
                            $(_this.$refs.stock_total).text(data.response.result.data.sum);
                            $(_this.$refs.stock_price_total).text(data.response.result.data.sum_price);
                        } else {
                            Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: []
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 获取导出设置
            getExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "stock/stockExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.export_checkModel = data.response.result.export_fields;
                                _this.export_type = data.response.result.export_type;
                            } else {
                                _this.export_checkModel = _this.export_checkData;
                                _this.export_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.export_alert)
                }, function() {
                    _this.stockExport();
                });
            },
            // 导出字段全选
            exportCheckedAll: function() {
                let _this = this;
                _this.export_allcheck = _this.c_export_allcheck;
                if(!_this.export_allcheck) { // 实现全选
                    _this.export_checkModel = [];
                    _this.export_checkData.forEach(function(item) {
                        _this.export_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.export_checkModel = [];
                }
            },
            // 点击导出
            stockExport: function() {
                let _this = this;
                let shop_id = $(_this.$refs.selectstore).val();
                let store_id = "";
                let export_fields = JSON.stringify(_this.export_checkModel);
                
                if($(_this.$refs.printer_stock_input).val() !== null && $(_this.$refs.printer_stock_input).val() != "") {
                    store_id = $.trim($(_this.$refs.printer_stock_input).val());
                }
                window.location.href = Vue.ctUrl + "stock/stockExport?" +
                    "shop_id=" + shop_id +
                    "&store_id=" + store_id +
                    "&is_lack=" + _this.is_lack +
                    "&merchant_goods_name=" + _this.goods_name + 
                    "&goods_type=" + $(_this.$refs.selecttypes).val() +
                    "&is_sell=" + $.trim($(_this.$refs.actual_sale).val()) +
                    "&time=" + _this.act_endtime +
                    "&order=" + _this.order +
                    "&order_by=" + _this.order_by +
                    "&sort_by=" + _this.sort_by +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.export_type;
                layer.msg("导出成功！");
                layer.closeAll();
            },
            // 点击“查询”
            searchStockList:function () {
                let _this = this;
                _this.is_lack = 0;
                _this.initStockTable();
            },
            // 点击“缺货查询”
            searchLack:function () {
                let _this = this;
                _this.query = true;
                _this.is_lack = 1;
                if(($(_this.$refs.selecttypes).val() == null) || ($(_this.$refs.selecttypes).val() == '')) {
                    _this.goods_type = null;
                }
                $(_this.$refs.stockTable).bootstrapTable('refreshOptions',{pageNumber:1});
            },
            // 点击“取消缺货查询”
            cancelLack:function () {
                let _this = this;
                _this.query = false;
                _this.is_lack = 0;
                if(($(_this.$refs.selecttypes).val() == null) || ($(_this.$refs.selecttypes).val() == '')) {
                    _this.goods_type = null;
                }
                $(_this.$refs.stockTable).bootstrapTable('refreshOptions',{pageNumber:1});
            },
            // 关闭弹窗
            closePop:function () {
                this.popup = false;
            },
            // 修改最小库存预警
            updateStock:function (id,num) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id,//库存id
                            "alerte_total": num//最小库存
                        }
                    },
                    "comment": []
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "stock/updateStock",
                    data: {
                        json: datas2
                    },
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            layer.msg("修改成功",{
                                time: 1200
                            });
                        } else {
                             Vue.timeoutfun(data.response.result_status,_this);
                            layer.msg(data.response.error_msg);

                        }
                    },
                    error: function(err) {
                        layer.msg("网络错误");
                    }
                });
            },
            // 判断小数
            isDecimal:function (num) {
                let _this = this;
                let regu = "^([0-9]*[.0-9])$"; // 小数测试
                let re = new RegExp(regu);
                if(num.search(re) != -1) {
                    return true;
                }else {
                    return false;
                }
            }
        }
    }
</script>

<style lang="less" >
    .actual-stock {
        .act-endtime[readonly] {
            background: #FFF;
            cursor: pointer;
        }
        .pull-right {
            button {
                margin: 0 0 0 30px;
            }
        }
        .editinput {
            position: relative;
            display: block;
            width: 75%;
            float: left;
            border: none;
            outline: 0;
            box-shadow: none;
            margin-left: 0;
            margin-right: 0;
            resize: none;
            height: 20px;
            line-height: 20px;
            text-align: center;
            word-break: break-all;
            padding: 0!important;
        }
        .editicon {
            width: 32px;
            height: 32px;
            background: url(../../assets/images/editstart.png) no-repeat center;
            background-size: 46%!important;
            display: block;
            float: right;
            margin-top: -6px;
            margin-bottom: -6px;
        }
        .editiconend {
            background: url(../../assets/images/editnote.png) no-repeat center;
        }
        .set-export {
            padding: 0 20px 20px;
            h3 {
                font-size: 16px;
            }
            li {
                float: left;
                width: 20%;
            }
        }
    }
    .changestock {
        height: 38px;
        width: 260px;
        border: 1px solid #d5d5d5;
        margin: 30px 0 0 35px;
        font-size: 14px;
        padding-left: 10px;
    }
    .red-text {
        color: #ff0000;
    }
</style>
